import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=14b9afdd&"
import script from "./comentarios.vue?vue&type=script&lang=ts&"
export * from "./comentarios.vue?vue&type=script&lang=ts&"
import style0 from "./comentarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports